import { ErrorMessage } from "@hookform/error-message";
import { type ReactElement, useMemo } from "react";
import { Tooltip } from "antd";
import {
  type Control,
  Controller,
  type FieldErrors,
  type FieldValues,
  type Path,
  type RegisterOptions,
} from "react-hook-form";
import { useIntl } from "react-intl";
import styled from "styled-components";
import TooltipIcon from "./TooltipIcon";

const StyledLabel = styled.label`
  margin-right: 5px;
`;
interface Props<T extends FieldValues> {
  labelText: string;
  labelTooltip?: string;
  name: Path<T>;
  rules?: RegisterOptions;
  control: Control<T>;
  render: (props: { field: FieldValues; fieldState }) => ReactElement;
  errors?: FieldErrors;
  labelTooltipId?: string;
}
const FormControl = <T extends FieldValues>({
  labelText,
  labelTooltip,
  control,
  name,
  rules,
  render,
  errors,
  labelTooltipId,
}: Props<T>) => {
  const { formatMessage } = useIntl();
  const tooltipId: string = useMemo(() => {
    if (labelTooltipId) {
      return `tooltip${labelTooltipId}`;
    }
    return `tooltip-${name}`;
  }, [labelTooltipId, name]);
  return (
    <>
      <StyledLabel id={tooltipId}>
        {formatMessage({ id: `${labelText}` })}
        {rules?.required && <span style={{ color: "red" }}>*</span>}
        {labelTooltip && (
          <Tooltip title={formatMessage({ id: `${labelTooltip}` })}>
            <span>
              <TooltipIcon />
            </span>
          </Tooltip>
        )}
      </StyledLabel>
      <Controller name={name} rules={rules as any} control={control} render={render} />
      <div style={{ color: "red", height: 21 }}>{errors && <ErrorMessage errors={errors} name={name} />}</div>
    </>
  );
};

export default FormControl;
